import { useCachedQuery } from '../../hooks/useCachedQuery';

export function useAgendaBlocks(professionalId) {
  const url = professionalId ? `/agenda-blocks/professionals/${professionalId}` : '/agenda-blocks';

  const { data, isLoading, isStale, updatedAt, error, refetch } = useCachedQuery(url);

  return {
    agendaBlocks: data ?? [],
    isLoading,
    isStale,
    updatedAt,
    error,
    refetch,
  };
}
